import NFSelect from "../Select/Select";
import {components} from "react-select";
import React from "react";
import {usePhrase} from "../../i18n";


const QuantitySelect = (props) => {

    const t = usePhrase(props._t);

    const Control = (controlProps) => {

        return <components.Control  className={'!rounded-xl lg:rounded  lg:!py-1 cursor-pointer'} {...controlProps}>
            {props.prefix && <div className={'ml-2 font-normal'}>{props.prefix}</div>}
            {controlProps.children}
        </components.Control>
    };
    const ValueContainer = ({children, ..._props}) => (
        <components.ValueContainer {..._props}>
            <div className={'flex'}>
                {props?.qtyLabel && <div className={'hidden lg:block mr-0.5'}>{t('Qty')}:</div>}
                {children}
            </div>
        </components.ValueContainer>
    );

    return <NFSelect  components={{ValueContainer, Control}} styles={{
        control: {
            height: '48px',
            border: 'none',
            background: '#f5f5f5',
            padding: '0px 2px',
            boxShadow: 'none',
            cursor: 'pointer',
            '&:hover': {
                background: '#e7e7e7'
            }
        },
        dropdownIndicator: {
            padding: '4px'
        }
    }} {...props} />

}

export default QuantitySelect;